import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections.tsx';
import type { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import type { AudienceListType, FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { SelectFlatSegments } from '../../drawer/components/SelectFlatSegments.tsx';
import { LocationSegmentsList } from './LocationSegmentsList.tsx';
import { createSegmentDeleteHandler } from './utils/createSegmentDeleteHandler.ts';

export type LocationStateProps = {
  isEdit: boolean;
  listType: AudienceListType;
  locationStateSegments: FormSegment[];
  setLocationStateSegments: Dispatch<SetStateAction<FormSegment[]>>;
  options: FormSegment[];
};

export const LocationState = ({
  isEdit,
  listType,
  locationStateSegments,
  setLocationStateSegments,
  options,
}: LocationStateProps) => {
  const { t } = useTranslation();

  return (
    <IndentedSections>
      {isEdit && (
        <SelectFlatSegments
          options={options}
          label={t('State')}
          placeholder={t('[ Select or Search State ]')}
          dataTest="state-dropdown"
          selectedSegments={locationStateSegments}
          setSelectedSegments={setLocationStateSegments}
        />
      )}

      {locationStateSegments.length > 0 && (
        <LocationSegmentsList
          listType={listType}
          locationSegments={locationStateSegments}
          onSegmentDelete={createSegmentDeleteHandler(locationStateSegments, setLocationStateSegments)}
          dataTest="state"
        />
      )}
    </IndentedSections>
  );
};
